// src/pages/services/AllServices.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./Services.css"; // We’ll define card layout in here

function AllServices() {
  return (
    <div className="services-page">
      <h2>Our Services</h2>
      <div className="services-grid">

        <div className="service-card">
          <h3>Orthopaedic Physical Therapy</h3>
          <p>
            Focuses on treating musculoskeletal injuries, helping patients regain
            strength and mobility.
          </p>
          <Link to="/services/orthopaedic" className="card-link">Learn More</Link>
        </div>

        <div className="service-card">
          <h3>Post Surgical Physical Therapy</h3>
          <p>
            Specialized rehab programs to ensure smooth recovery and restore
            function after surgeries.
          </p>
          <Link to="/services/post-surgical" className="card-link">Learn More</Link>
        </div>

        <div className="service-card">
          <h3>Neuro Physical Therapy</h3>
          <p>
            Helps patients with neurological conditions to improve function,
            mobility, and overall quality of life.
          </p>
          <Link to="/services/neuro" className="card-link">Learn More</Link>
        </div>

        <div className="service-card">
          <h3>Preoperative Prehabilitation</h3>
          <p>
            Prepare your body for surgery with exercise programs that can improve
            post-surgical outcomes and recovery.
          </p>
          <Link to="/services/preoperative" className="card-link">Learn More</Link>
        </div>

      </div>
    </div>
  );
}

export default AllServices;
